// Chakra imports
import { Flex } from "@chakra-ui/react";
import React,{useState, useEffect} from "react";
import UsersTable from "./components/UsersTable";
import { tablesTableData, dashboardTableData } from "variables/general";
import axios from 'axios';
import { getToken } from "utils/auth";
import config from "config";

function Users() {
  const [userProfiles, setUserProfiles] = useState([]);
  const [currentUserEmail, setCurrentUserEmail] = useState(null);

  useEffect(() => {
    const fetchUserProfiles = async () => {
      const token = getToken();
      try {
        const [usersRes, profileRes] = await Promise.allSettled([
          axios.get(`${config.API_URL}/user/users`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${config.API_URL}/user/profile`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        if (usersRes.status === "fulfilled") {
          setUserProfiles(usersRes.value.data);
        }

        if (profileRes.status === "fulfilled" && profileRes.value.data?.email) {
          const email = profileRes.value.data.email.toLowerCase();
          localStorage.setItem("user_email", email);
          setCurrentUserEmail(email);
        }
      } catch (error) {
        console.error("Error fetching user profiles:", error);
      }
    };

    fetchUserProfiles();
  }, []);

  return (
    <Flex direction='column' pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <UsersTable
        title={"Users Table"}
        captions={["User", "Role", "Function", "Action"]}
        data={userProfiles}
        setUserProfiles={setUserProfiles}
        currentUserEmail={currentUserEmail}
      />
    </Flex>
  );
}

export default Users;
